import 'whatwg-fetch';
import { checkStatus, authorization } from 'actions/utils/fetch_utils';
import { apiBasename } from 'actions/config/api';

export const fetchRegularContractInvoice = (id) => {
	return fetch(apiBasename + '/regularContractInvoice/' + id, authorization())
	.then(checkStatus)
	.then((res) => res.blob());
};

export const sendRegularContractInvoice = (id) => {
	return fetch(apiBasename + '/regularContractInvoice/' + id, authorization({
		method: 'POST'
	}))
	.then(checkStatus)
	.then((res) => res.json());
}

export const updateRegularContractInvoice = (id, changes) => {
	return fetch(apiBasename + '/regularContractInvoice/' + id, authorization({
		method: 'PUT',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(changes)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removeRegularContractInvoice = (id) => {
	return fetch(apiBasename + '/regularContractInvoice/' + id, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
};

export const addRegularContractInvoiceModification = (id, modif) => {
	return fetch(apiBasename + '/regularContractInvoice/' + id + '/modifications', authorization({
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(modif)
	}))
	.then(checkStatus)
	.then((res) => res.json());
};

export const removeRegularContractInvoiceModification = (id, modifId) => {
	return fetch(apiBasename + '/regularContractInvoice/' + id + '/modifications/' + modifId, authorization({
		method: 'DELETE'
	}))
	.then(checkStatus);
}
